module.exports = __webpack_public_path__ + "static/img/sd1.9466c83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/sd1.png
// module id = 5YkG
// module chunks = 0